import {ServicesList} from "../../data/data-class/devices/deviceServiceClass";
import ViaqTryCatch from "../../services/GlobalTryCatch";
import axiosInstance from "../../services/axios";

class DeviceServiceRepository {
    static async getList(text, pageNumber) {
        const data = {
            text: text,
            pagenumber: pageNumber,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/service", data)
            });

        const code = response.statusCode;
        const message = response.message;

        if (response.success) {
            const serviceObject = response.data.List.map(
                (device) =>
                    new ServicesList(
                        device.id,
                        device.serviceNumber,
                        device.serialNumber,
                        device.dateOfregistration,
                        device.name,
                        device.phoneNumber.replace("+98", "0"),
                        device.serviceType
                    )
            );
            const countAll = response.data.countAll;
            return {
                List_data: serviceObject,
                countAllPages: countAll,
                code,
                message,

            };
        }

        return {
            code,
            message,

        };
    }

    static async delete(id) {
        const data = {
            id: id,
        };
        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/service/delete", data)
            });

    }
}

class ServiceModalData {
    static async getdata(id) {
        const data = {
            id_page: id,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/service/details", data)
            });

        const modaldatad = response.data.detail;
        return {
            modaldatad,
        };
    }

    static async getDetail(id) {
        const data = {
            id_page: id,
        };
        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/service/details", data)
            });


    }

    static async addservice(data) {
        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/service/add", data)
            });

    }

    static async editservice(data) {
        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/service/edit", data)
            });
    }

    static async getserialnumber(text) {
        const data = {
            text: text,
        };
        // const val = await postRequestWithToken("/service/get-serial-number", data);
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/service/get-serial-number", data)
            });
        const code = response.statusCode;
        const message = response.message;
        if (response.success) {
            const datal = response.data.serialNumber;
            return {
                serialN: datal,
                code,
                message,
            };
        }
        return {
            code,
            message,
        };

    }
}

class ServiceDetailRepository {
    static async getDetail(id_page) {
        ////Check Error From This
        const data = {
            id_page: id_page,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/service/details", data)
            });
        const responseData = response.data;
        const code = response.statusCode;
        const message = response.message;
        const id = responseData.detail.id ?? null;
        const serviceNumber = responseData.detail.serviceNumber ?? null;
        const serialNumber = responseData.detail.serialNumber ?? null;
        const dateTime = responseData.detail.dateTime ?? null;
        const nameOwner = responseData.detail.nameOwner ?? null;
        const numberOwner = responseData.detail.numberOwner ?? null;
        const service = responseData.detail.service ?? null;
        const TextDetail = responseData.detail.TextDetail ?? null;

        return {
            id,
            serviceNumber,
            serialNumber,
            dateTime,
            nameOwner,
            numberOwner,
            service,
            TextDetail,
            code,
            message,
        };
    }

    static async delete(id) {
        const data = {
            id: id,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/service/delete", data)
            });
        const code = response.statusCode;
        const massage = response.message;
        return {
            code,
            massage,
        };
    }
}

export {ServiceDetailRepository};
export {DeviceServiceRepository};
export {ServiceModalData};
